import React, { FC, useState } from 'react';
import { Button, Icon, Modal, ModalActions, ModalContent, ModalHeader } from 'semantic-ui-react';
import { TranslationComponent } from '../TranslationComponent';

type Props = { onDelete: () => void; detailScreen?: boolean; error?: string };

export const EhsDeleteModal: FC<Props> = ({ onDelete, detailScreen, error }) => {
  const [showModal, setShowModal] = useState(false);

  const handleDelete = () => {
    onDelete();
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      trigger={
        <Button
          fluid={detailScreen}
          type={'button'}
          icon={!detailScreen}
          style={{ marginTop: 8 }}
          onClick={(event) => {
            event.stopPropagation();
            setShowModal(true);
          }}
        >
          {detailScreen ? <TranslationComponent stringKey={'Delete Ehs'} /> : <Icon name={'trash alternate'} />}
        </Button>
      }
    >
      <ModalHeader>
        <TranslationComponent stringKey={'Delete Ehs'} />
      </ModalHeader>
      <ModalContent>
        {error ?? <TranslationComponent stringKey={'You are about to permanently delete this EHS'} />}
      </ModalContent>
      <ModalActions>
        <>
          <Button onClick={() => setShowModal(false)}>
            <TranslationComponent stringKey={'Cancel'} />
          </Button>
          <Button onClick={handleDelete} disabled={!!error}>
            <TranslationComponent stringKey={'Delete'} />
          </Button>
        </>
      </ModalActions>
    </Modal>
  );
};
